// extracted by mini-css-extract-plugin
export default {"tableTime":"TimeLabel_tableTime__DbSWH"};